var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26304_39266)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6456 11C27.3115 11 27.8512 11.5398 27.8512 12.2056V27.2664C27.8512 27.9323 27.3115 28.472 26.6456 28.472H14.2056C13.5398 28.472 13 27.9323 13 27.2664V12.2056C13 11.5398 13.5398 11 14.2056 11H26.6456ZM21.6717 23.1158H16.0283C15.6664 23.1158 15.3731 23.4092 15.3731 23.771C15.3731 24.1329 15.6664 24.4262 16.0283 24.4262H21.6717C22.0336 24.4262 22.3269 24.1329 22.3269 23.771C22.3269 23.4092 22.0336 23.1158 21.6717 23.1158ZM24.8435 18.9858H16.0283C15.6664 18.9858 15.3731 19.2791 15.3731 19.641C15.3731 20.0029 15.6664 20.2962 16.0283 20.2962H24.8435C25.2054 20.2962 25.4987 20.0029 25.4987 19.641C25.4987 19.2791 25.2054 18.9858 24.8435 18.9858ZM24.7855 14.8634H15.9702C15.6084 14.8634 15.315 15.1568 15.315 15.5186C15.315 15.8805 15.6084 16.1738 15.9702 16.1738H24.7855C25.1473 16.1738 25.4407 15.8805 25.4407 15.5186C25.4407 15.1568 25.1473 14.8634 24.7855 14.8634Z",
    fill: "#4251DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26304_39266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownList);
export default __webpack_public_path__ + "static/media/dropdown-list.c57984174d4d5fc97cb7603b0920d824.svg";
export { ForwardRef as ReactComponent };